"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSimplePassengersToString = transformSimplePassengersToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformSimplePassengersToString(passengers) {
    const adults = passengers.filter((p) => p.type === legacy_enums_1.PassengerType.Adult || p.type === legacy_enums_1.PassengerType.Lead);
    const children = passengers.filter((p) => p.type === legacy_enums_1.PassengerType.Child);
    return `${adults.length}x ${adults.length > 1 ? "adults " : "adult "}${children.length > 0 ? ` & ${children.length.toString()}x ${children.length > 1 ? "children " : "child "}` : ""}`;
}
//# sourceMappingURL=transformSimplePassengersToString.js.map